var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseModal", {
    attrs: {
      id: _vm.id,
      modalClass: "modal-md",
      headerText: _vm.$t("message.refdoclog"),
      showCloseButton: false,
      cancelButtonText: _vm.$t("button.cancel"),
      sumitButtonText: _vm.$t("button.save"),
      isSubmitted: _vm.isSubmitted
    },
    on: { onCancel: _vm.handleCancel, onSubmit: _vm.handleSubmit },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "container-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.topic")) + " *")
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.topic.$model,
                            expression: "$v.topic.$model"
                          }
                        ],
                        staticClass: "form-control custom-select",
                        class: [{ "is-invalid": _vm.$v.topic.$error }],
                        attrs: { disabled: _vm.isSubmitted || _vm.isEdit },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.$v.topic,
                              "$model",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v(_vm._s(_vm.$t("placeholder.select")))
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.filterLogTopics, function(topic, index) {
                          return _c(
                            "option",
                            { key: index, domProps: { value: topic.value } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(topic.text) +
                                  "\n              "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.description")))
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.$v.description.$model,
                          expression: "$v.description.$model"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "min-height": "52px" },
                      attrs: { disabled: _vm.isSubmitted },
                      domProps: { value: _vm.$v.description.$model },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.$v.description,
                            "$model",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.scheduledate")))
                      ]),
                      _vm._v(" "),
                      _c("BaseInputDatePicker", {
                        attrs: {
                          disabled: _vm.isSubmitted,
                          mode: "dateTime",
                          is24hr: ""
                        },
                        model: {
                          value: _vm.$v.schedule_date.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.schedule_date, "$model", $$v)
                          },
                          expression: "$v.schedule_date.$model"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-519c2ecb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-519c2ecb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModalDocRefLog.vue
// module id = null
// module chunks = 